module.exports = __webpack_public_path__ + "img/ug.d4979cba.svg";